import { useQuery } from "@tanstack/react-query";
import {
	getSale,
	getSalePayments,
	getSaleProducts,
	getSales,
	getSalesReport,
} from "../api";

export const useSales = (filters) =>
	useQuery({
		queryFn: () => getSales(filters),
		queryKey: ["sales", filters],
	});

export const useSale = (id) =>
	useQuery({
		queryFn: () => getSale(id),
		queryKey: ["sales", { id }],
	});

export const useSaleProducts = (filters) =>
	useQuery({
		queryFn: () => getSaleProducts(filters),
		queryKey: ["saleProducts", filters],
	});
export const useSalePayments = (filters, enabled) =>
	useQuery({
		queryFn: () => getSalePayments(filters),
		queryKey: ["salePayments", filters],
		enabled,
	});

// Under the "sales" key so a sale made at the checkout refreshes it.
export const useSalesReport = (params: Parameters<typeof getSalesReport>[0]) =>
	useQuery({
		queryFn: () => getSalesReport(params),
		queryKey: ["sales", "report", params],
		enabled: !!params.storeId,
	});
